module.exports = __webpack_public_path__ + "static/img/jylhBanner.4cc56626.png";